import React from 'react';
import { TaskCommentRowsSkeleton } from '../../common/ContentSkeletons';

export default function EventTaskCommentDock({ view }) {
  const {
    PersonAvatar,
    TASK_COMMENT_REACTION_OPTIONS,
    eventTaskCanEdit,
    eventTaskCommentReactionBusyMap,
    eventTaskDetailCommentBody,
    eventTaskDetailComments,
    eventTaskDetailCommentsLoading,
    eventTaskDetailFeedTab,
    eventTaskDetailPostingComment,
    eventTaskDetailTask,
    formatDateTimeJST,
    getEventTaskCommentAuthorAvatarUrl,
    getEventTaskCommentAuthorName,
    handlePostEventTaskComment,
    handleToggleEventTaskCommentReaction,
    mapEventTaskCommentReactions,
    setEventTaskDetailCommentBody,
    setEventTaskDetailFeedTab,
  } = view;

  return (
    <>
                      <div className="event-task-detail-modal__commentDock">
                        <div className="event-task-detail-modal__commentDockTabs" role="tablist" aria-label="タスク詳細フィード">
                          <button
                            type="button"
                            role="tab"
                            id="event-task-feed-tab-comments"
                            aria-selected={eventTaskDetailFeedTab === 'comments'}
                            aria-controls="event-task-feed-panel-comments"
                            className={eventTaskDetailFeedTab === 'comments' ? 'is-active' : ''}
                            onClick={() => setEventTaskDetailFeedTab('comments')}
                          >
                            コメント
                          </button>
                          <button
                            type="button"
                            role="tab"
                            id="event-task-feed-tab-activity"
                            aria-selected={eventTaskDetailFeedTab === 'activity'}
                            aria-controls="event-task-feed-panel-activity"
                            className={eventTaskDetailFeedTab === 'activity' ? 'is-active' : ''}
                            onClick={() => setEventTaskDetailFeedTab('activity')}
                          >
                            すべてのアクティビティ
                          </button>
                        </div>
                        <div className="event-task-detail-modal__commentDockFeed">
                          {eventTaskDetailCommentsLoading ? (
                            <TaskCommentRowsSkeleton
                              rows={3}
                              classPrefix="event-task-detail-modal"
                            />
                          ) : eventTaskDetailFeedTab === 'comments' ? (
                            eventTaskDetailComments.length === 0 ? (
                              <p className="event-task-detail-modal__emptyText">コメントはまだありません。</p>
                            ) : (
                              <ul
                                id="event-task-feed-panel-comments"
                                role="tabpanel"
                                aria-labelledby="event-task-feed-tab-comments"
                                className="event-task-detail-modal__commentList"
                              >
                                {eventTaskDetailComments.map((comment) => {
                                  const authorName = getEventTaskCommentAuthorName(comment);
                                  const authorAvatarUrl = getEventTaskCommentAuthorAvatarUrl(comment);
                                  const reactionMap = mapEventTaskCommentReactions(comment);
                                  return (
                                    <li key={comment.id} className="event-task-detail-modal__commentItem">
                                      <div className="event-task-detail-modal__commentHead">
                                        <div className="event-task-detail-modal__commentAuthor">
                                          <PersonAvatar
                                            role="admin"
                                            name={authorName}
                                            imageUrl={authorAvatarUrl}
                                            className="event-task-detail-modal__commentAvatar"
                                            size={20}
                                          />
                                          <strong>{authorName}</strong>
                                        </div>
                                        <span>
                                          {comment.createdAt
                                            ? formatDateTimeJST(comment.createdAt)
                                            : ''}
                                        </span>
                                      </div>
                                      <p>{comment.body || ''}</p>
                                      <div
                                        className="event-task-detail-modal__commentReactions"
                                        role="group"
                                        aria-label="コメントリアクション"
                                      >
                                        {TASK_COMMENT_REACTION_OPTIONS.map((reactionOption) => {
                                          const reaction = reactionMap.get(reactionOption.emoji);
                                          const reactionCount = Number(reaction?.count || 0);
                                          const reactedByMe = Boolean(reaction?.reactedByMe);
                                          const pendingKey = `${comment.id}:${reactionOption.emoji}`;
                                          const isPending = Boolean(eventTaskCommentReactionBusyMap[pendingKey]);
                                          return (
                                            <button
                                              key={`${comment.id}-${reactionOption.emoji}`}
                                              type="button"
                                              className={`event-task-detail-modal__commentReactionBtn ${
                                                reactionCount > 0 ? 'has-count' : ''
                                              } ${reactedByMe ? 'is-active' : ''}`}
                                              onClick={() => {
                                                void handleToggleEventTaskCommentReaction(
                                                  comment.id,
                                                  reactionOption.emoji
                                                );
                                              }}
                                              disabled={!eventTaskCanEdit || isPending}
                                              aria-label={`${reactionOption.label}リアクション`}
                                              title={reactionOption.label}
                                            >
                                              <span>{reactionOption.emoji}</span>
                                              {reactionCount > 0 ? <em>{reactionCount}</em> : null}
                                            </button>
                                          );
                                        })}
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            )
                          ) : (
                            <ul
                              id="event-task-feed-panel-activity"
                              role="tabpanel"
                              aria-labelledby="event-task-feed-tab-activity"
                              className="event-task-detail-modal__commentList"
                            >
                              <li className="event-task-detail-modal__commentItem">
                                <div className="event-task-detail-modal__commentHead">
                                  <div className="event-task-detail-modal__commentAuthor">
                                    <PersonAvatar
                                      role="admin"
                                      name={eventTaskDetailTask.createdByDisplayName || '管理者'}
                                      imageUrl={eventTaskDetailTask.createdByAvatarUrl || ''}
                                      className="event-task-detail-modal__commentAvatar"
                                      size={20}
                                    />
                                    <strong>{eventTaskDetailTask.createdByDisplayName || '管理者'}</strong>
                                  </div>
                                  <span>
                                    {eventTaskDetailTask.createdAt
                                      ? formatDateTimeJST(eventTaskDetailTask.createdAt)
                                      : ''}
                                  </span>
                                </div>
                                <p>このタスクを作成しました。</p>
                              </li>
                              {eventTaskDetailComments.map((comment) => {
                                const authorName = getEventTaskCommentAuthorName(comment);
                                const authorAvatarUrl = getEventTaskCommentAuthorAvatarUrl(comment);
                                const reactionMap = mapEventTaskCommentReactions(comment);
                                return (
                                  <li key={`activity-${comment.id}`} className="event-task-detail-modal__commentItem">
                                    <div className="event-task-detail-modal__commentHead">
                                      <div className="event-task-detail-modal__commentAuthor">
                                        <PersonAvatar
                                          role="admin"
                                          name={authorName}
                                          imageUrl={authorAvatarUrl}
                                          className="event-task-detail-modal__commentAvatar"
                                          size={20}
                                        />
                                        <strong>{authorName}</strong>
                                      </div>
                                      <span>
                                        {comment.createdAt
                                          ? formatDateTimeJST(comment.createdAt)
                                          : ''}
                                      </span>
                                    </div>
                                    <p>{comment.body || ''}</p>
                                    <div
                                      className="event-task-detail-modal__commentReactions"
                                      role="group"
                                      aria-label="コメントリアクション"
                                    >
                                      {TASK_COMMENT_REACTION_OPTIONS.map((reactionOption) => {
                                        const reaction = reactionMap.get(reactionOption.emoji);
                                        const reactionCount = Number(reaction?.count || 0);
                                        const reactedByMe = Boolean(reaction?.reactedByMe);
                                        const pendingKey = `${comment.id}:${reactionOption.emoji}`;
                                        const isPending = Boolean(eventTaskCommentReactionBusyMap[pendingKey]);
                                        return (
                                          <button
                                            key={`activity-${comment.id}-${reactionOption.emoji}`}
                                            type="button"
                                            className={`event-task-detail-modal__commentReactionBtn ${
                                              reactionCount > 0 ? 'has-count' : ''
                                            } ${reactedByMe ? 'is-active' : ''}`}
                                            onClick={() => {
                                              void handleToggleEventTaskCommentReaction(
                                                comment.id,
                                                reactionOption.emoji
                                              );
                                            }}
                                            disabled={!eventTaskCanEdit || isPending}
                                            aria-label={`${reactionOption.label}リアクション`}
                                            title={reactionOption.label}
                                          >
                                            <span>{reactionOption.emoji}</span>
                                            {reactionCount > 0 ? <em>{reactionCount}</em> : null}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                        {eventTaskCanEdit ? (
                          <div className="event-task-detail-modal__commentComposer">
                            <textarea
                              value={eventTaskDetailCommentBody}
                              onChange={(e) => setEventTaskDetailCommentBody(e.target.value)}
                              placeholder="コメントを追加"
                              onKeyDown={(e) => {
                                if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
                                  e.preventDefault();
                                  void handlePostEventTaskComment();
                                }
                              }}
                              disabled={eventTaskDetailPostingComment}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                void handlePostEventTaskComment();
                              }}
                              disabled={
                                eventTaskDetailPostingComment || !String(eventTaskDetailCommentBody).trim()
                              }
                            >
                              {eventTaskDetailPostingComment ? '投稿中...' : 'コメント投稿'}
                            </button>
                          </div>
                        ) : null}
                      </div>
    </>
  );
}
